import { pick } from 'lodash';
import { useContextSelector } from 'use-context-selector';
import { OnboardingContext } from '..';

export const useOnboardingContext = () => {
  const values = useContextSelector(OnboardingContext, (state) =>
    pick(state, ['profile', 'clearOnboarding', 'errors'])
  );

  return values;
};
